import { FC, memo } from 'react'

import { NavLink } from 'react-router-dom'

import { useAppDispatch } from '@App/hooks'
import { RegisterIcon } from '@App/static/icons/HeaderIcon'
import { ROUTE_NAMES } from '@App/ui/crypto_exchange/desktop/routes/routeNames'

import { MODAL_TYPES } from '@Redux/slices/modals/enums'
import { setModal } from '@Redux/slices/modals/ModalSlice'

import classes from './AuthorizationButtons.module.scss'

export const AuthorizationButtons: FC = memo(() => {
  const dispatch = useAppDispatch()

  return (
    <div className={classes.authorizationContainer}>
      <div className={classes.logIn} onClick={() => dispatch(setModal({ modalType: MODAL_TYPES.LOGIN_MODAL }))}>
        Log In
      </div>
      <div className={classes.register} onClick={() => dispatch(setModal({ modalType: MODAL_TYPES.REGISTRATION_MODAL }))}>
        <RegisterIcon className={classes.registerIcon} />
        Register
      </div>
    </div>
  )
})
